import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { Input } from '~/components/ui/input'
import { Label } from '~/components/ui/label'

type Props = {
  busy: boolean
  /** `true` si la correction est enregistrée : le formulaire se vide alors. */
  onSubmit: (percent: number, reason: string) => Promise<boolean>
}

/** Saisie d'une correction (#161) : un score en %, un motif obligatoire. */
function ScoreCorrectionForm({ busy, onSubmit }: Props) {
  const { t } = useTranslation()
  const [percent, setPercent] = useState('')
  const [reason, setReason] = useState('')
  const value = Number(percent)
  const valid = percent !== '' && Number.isFinite(value) && value >= 0 && value <= 100 && reason.trim() !== ''

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!valid || busy) return
    if (await onSubmit(value, reason.trim())) {
      setPercent('')
      setReason('')
    }
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-3">
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="correctedScore" required>{t('scoreCorrection.percent')}</Label>
        <Input id="correctedScore" type="number" min={0} max={100} step="any" className="w-32" value={percent} onChange={e => setPercent(e.target.value)} required />
      </div>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="correctionReason" required>{t('scoreCorrection.reason')}</Label>
        <textarea
          id="correctionReason"
          rows={3}
          value={reason}
          onChange={e => setReason(e.target.value)}
          required
          aria-describedby="correctionReasonHelp"
          className="rounded-md border border-input bg-transparent px-3 py-2 text-sm"
        />
        <p id="correctionReasonHelp" className="text-xs text-muted-foreground">{t('scoreCorrection.reasonHelp')}</p>
      </div>
      <Button type="submit" className="w-fit" disabled={!valid || busy}>{t('scoreCorrection.save')}</Button>
    </form>
  )
}

export default ScoreCorrectionForm
